import React from "react";
import { SsoCallbackView } from "@nrgpix/auth-sso";
import SustinaSsoProvider from "./SustinaSsoProvider";

/** Where every identity provider sends the browser back (sign-in and set-up tests). */
export default function SsoCallbackPage() {
    return (
        <main id="main" className="page-main registered-page" data-scroll-container>
            <SustinaSsoProvider>
                <SsoCallbackView returnTo="/registered/company-sso" />
            </SustinaSsoProvider>
        </main>
    );
}
